const initialsValidatior = (initials) => {
  const initialsRegex = /^[-.a-zA-Z]{2,8}$/;

  return initialsRegex.test(initials);
};

export default initialsValidatior;